export enum AnalyticsValidationTypesEnum {
  RESULT = 'RESULT',
  FULL_FILLED = 'FULL_FILLED',
}
